import { makeStyles, tokens } from "@fluentui/react-components";
import React from "react";
import { OverviewXYZ } from "./OverviewXYZ";
import { OverviewYQB } from "./OverviewYQB";

export const cardMinHeight = "174px";

export const Overview: React.FunctionComponent<any> = ({ airport }) => {
  const classes = useStyles();

  sessionStorage.setItem("airportCode", airport);

  return (
    <div className={classes.gridContainer} data-testid="overview-page">
      {airport === "YQB" && <OverviewYQB airport={airport} />}
      {airport !== "YQB" && <OverviewXYZ airport={airport} />}
    </div>
  );
};

const useStyles = makeStyles({
  gridContainer: {
    display: "grid",
    gridGap: "20px",
    gridTemplateColumns: "repeat(3, minmax(214px, 1fr))",

    "& > *": {
      backgroundColor: tokens.colorNeutralBackground1,
      borderRadius: "8px",
      minHeight: cardMinHeight,
      boxShadow: "2px 4px 4px rgba(0, 0, 0, 0.15)",
    },
  },
});
